var observer; 

'use strict';
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(canCreateDiscussions) {
 return typeof canCreateDiscussions;
} : function(obj) {
 return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var themeJsInit;
(function() {
 function onload() {
   function init() {
     if (!_0xF6D5) {
       _0xF6D5 = true;
       document.querySelectorAll(match[3]).forEach(function(img) {
         datasrc = img.dataset.src;
         if (null != datasrc) {
           img.src = datasrc;
         }
       });
       var rows = document.getElementsByTagName(match[4]);
       var i = 0;
       for (i = 0; i < rows.length; i++) {
         if (null !== rows[i].getAttribute(match[5]) && (rows[i].setAttribute(match[6], rows[i].getAttribute(match[5])), delete rows[i].dataset.src), match[7] == rows[i].getAttribute(match[8])) {
           var elem = document.createElement(match[4]);
           var aidx = 0;
           for (; aidx < rows[i].attributes.length; aidx++) {
             var attr = rows[i].attributes[aidx];
             elem.setAttribute(attr.name, attr.value);
           }
           elem.type = match[9];
           elem.innerHTML = rows[i].innerHTML;
           rows[i].parentNode.removeChild(rows[i]);
           rows[i].parentNode.insertBefore(elem, rows[i]);
         }
       }
       var targets = document.getElementsByTagName(match[10]);
       i = 0;
       for (; i < targets.length; i++) {
         if (null !== targets[i].getAttribute(match[11])) {
           targets[i].setAttribute(match[12], targets[i].getAttribute(match[11]));
           delete targets[i].dataset.href;
         }
       }
       document.dispatchEvent(new CustomEvent(match[13]));
       setTimeout(function() {
         document.dispatchEvent(new CustomEvent(match[14]));
       }, 1000);
     }
   }
   var _0xF6D5 = false;
   window.addEventListener(match[15], function(canCreateDiscussions) {
     init();
   });
   window.addEventListener(match[16], function() {
     init();
   });
   window.addEventListener(match[17], function() {
     init();
   });
   if (window.addEventListener) {
     window.addEventListener(match[18], function() {
     }, false);
   } else {
     if (window.attachEvent) {
       window.attachEvent(match[19], function() {
       });
     } else {
       window.onload = function(fileLoadedEvent) {
       };
     }
   }
 }

    var match = ["undefined", "ruvido-caso.myshopify.com", "Unauthorised use of code detected. Refrain from using the copyrighted code without prior permission.", "iframe.lazy", "script", "data-src", "src", "lazyloadscript", "type", "text/javascript", "link", "data-href", "href", "StartKernelLoading", "asyncLazyLoad", "scroll", "mousemove", "touchstart", "load", "onload"];

   if (_typeof(Shopify.shop) !== match[0]) {

  if(Xzxs ){
   if (Shopify.shop !== match[1]) { 
     console.log(match[2]);
   } else { 
     themeJsInit = onload;
   }

  }
  }
})();
